import api from "./axios";

// Admin CRUD — assignment is folded into the create/update payload as
// `employee_ids`. The index response also carries a `limits` object
// ({ used, max }) for the "X / N geofences" cap display.
export const listGeofences = (params = {}) => api.get("/geofences", { params });
export const getGeofence = (id) => api.get(`/geofences/${id}`);
export const createGeofence = (payload) => api.post("/geofences", payload);
export const updateGeofence = (id, payload) => api.put(`/geofences/${id}`, payload);
export const deleteGeofence = (id) => api.delete(`/geofences/${id}`);

// Periodic re-check polled by the employee app shell.
export const checkGeofence = (latitude, longitude) =>
  api.post("/geofence/check", { latitude, longitude });
